import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule  } from "@angular/common";
import { UserRoleComponent } from "../user-role/user-role.component";
import { Router } from "@angular/router";
import { PrimeNGSharedModule } from "@shared/prime/prime-ng.module";

@Component({
  selector: "app-success-popup",
  standalone: true,
  imports: [CommonModule, UserRoleComponent,PrimeNGSharedModule ],
  templateUrl: "./success-popup.component.html",
  styleUrls: ["./success-popup.component.scss"],
})
export class SuccessPopupComponent {
  constructor(private router: Router) {}

  showCreateUserDialog: boolean = false;
  showNewUserDialog: boolean = false;
  selectedRoleForNewUser: string = "";

  @Input() visible: boolean = false;
  @Input() data: {
    isSuccess: boolean;
    title: string;
    message: string;
    userName: string;
    userRole: string;
  } = {
    isSuccess: true,
    title: "",
    message: "New User Created Successfully",
    userName: "",
    userRole: "",
  };

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeDialog = new EventEmitter<void>();
  @Output() addAnother = new EventEmitter<void>();

  ngOnInit(): void {
  }

  close(): void {
    if (this.data.isSuccess) {
      localStorage.removeItem("userDetails");
    }
    this.closeDialog.emit();
    this.router.navigate(["/user-profile"]);
  }

  addAnotherUser(): void {
    if (this.data.isSuccess) {
      localStorage.removeItem("userDetails");
    }
    this.showNewUserDialog = true;
    this.visibleChange.emit(false);
    this.addAnother.emit();
    this.closeDialog.emit();
  }

  onRoleSelected(role: string) {
    this.selectedRoleForNewUser = role;
    this.showCreateUserDialog = false;
    this.showNewUserDialog = true;
  }

  hasValidSelectedInjectors(): boolean {
    try {
      const stored = localStorage.getItem("selectedInjectors");
      if (!stored) return false;

      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) && parsed.some((i) => i.injectorId?.trim());
    } catch {
      return false;
    }
  }
}
